//libraries
import React, { useEffect, useState, useMemo, useCallback } from 'react';

// custom components
import RealStory from './components/RealStory';

// hooks
import { useHistory } from 'react-router-dom';
import useModal from 'hooks/useModal';

// api
import api from './api';

// services
import { convertRealStoryInfoToViewModel } from './services';

// utils
import { openPromotionalModal } from 'utils/openPromotionalModal';

const RealStoriesPageContainer = ({
  match: {
    params: { url },
  },
}: any): JSX.Element => {
  const history = useHistory();

  const [stories, setStories] = useState([]);

  const { handleModalOpen } = useModal();

  const [storyInfo, setStoryInfo] = useState({
    author: '',
    subtitle: '',
    featuredQuote: '',
    photoUrl: '',
    instagramHandle: '',
    body: '',
    tags: [],
  });

  const storiesWithoutCurrent = useMemo(() => stories.filter((stories: any) => stories.seoUrlStructure !== url), [
    url,
    stories,
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);

    (async (): Promise<any> => {
      try {
        const story = await api.getStory(url);

        const convertedStory = convertRealStoryInfoToViewModel(story.data);

        setStoryInfo(convertedStory);

        const stories = await api.getStories(false, false, convertedStory.tags);

        setStories(stories.data);
      } catch (err) {
        console.log(err);
      }
    })();
    openPromotionalModal(handleModalOpen);
  }, [url]);

  const handleStoryClick = useCallback(
    (url: string) => (): void => {
      history.push(`/journey/${url}`);
    },
    [history],
  );

  const handleCreateStoryClick = useCallback(() => {
    history.push('/share-your-journey');
  }, [history]);

  return (
    <RealStory
      storyInfo={storyInfo}
      stories={storiesWithoutCurrent}
      onStoryClick={handleStoryClick}
      onCreateStoryClick={handleCreateStoryClick}
    />
  );
};

export default RealStoriesPageContainer;
